export enum MerchantExchangeCausationKind {
  FiatInvoice = 'fiat-invoice',
  CryptoInvoice = 'crypto-invoice',
  CryptoReplenishment = 'crypto-replenishment'
}
